import { Card, Grid, Empty } from "antd";
import { useDataReviewLogic } from "../../hooks/useDataReviewLogic";
import { useColumnSelection } from "../../hooks/useColumnSelection";
import { useAnalyticsConfiguration } from "../../hooks/useAnalyticsConfiguration";
import TopBar from "./TopBar";
import PageHeader from "./PageHeader";
import ColumnSelectionCard from "./ColumnSelectionCard";
import AnalyticsConfigurationCard from "./AnalyticsConfigurationCard";
import AnalyticsProgressModal from "../AnalyticsProgressModal";

const { useBreakpoint } = Grid;

const DataReviewAndConfigure = () => {
  const screens = useBreakpoint();

  const {
    processResponse,
    applying,
    applyResponse,
    hasProcessResponse,
    onBack,
    onConfigure,
    onBackToDashboard
  } = useDataReviewLogic();

  const {
    columns,
    numericColumns,
    allColumns,
  } = useColumnSelection(processResponse);

  const {
    modalSelection,
    dependentVariable,
    groupBy,
    onChangeModal,
    onChangeDependent,
    onChangeGroupBy,
    dependentOptions,
    groupByOptions,
    MODEL_OPTIONS,
    ENSEMBLE_MODELS,
  } = useAnalyticsConfiguration(columns, numericColumns, allColumns);

  return (
    <div className="min-h-[100dvh] relative">
      <TopBar onBack={onBack} />
      <PageHeader screens={screens} />

      <AnalyticsProgressModal
        processing={applying}
        activeStep={applying ? 3 : 0}
        totalSteps={4}
        disableClose
        modalSelection={modalSelection}
        dependentVariable={dependentVariable}
        groupBy={groupBy}
        MODEL_OPTIONS={MODEL_OPTIONS}
      />

      <div className="p-4 sm:p-6">
        {!hasProcessResponse ? (
          <Card className="shadow-sm">
            <div className="py-20 flex items-center justify-center">
              <Empty description="No response found" />
            </div>
          </Card>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ColumnSelectionCard columns={columns} />
            <AnalyticsConfigurationCard
              modalSelection={modalSelection}
              dependentVariable={dependentVariable}
              groupBy={groupBy}
              onChangeModal={onChangeModal}
              onChangeDependent={onChangeDependent}
              onChangeGroupBy={onChangeGroupBy}
              dependentOptions={dependentOptions}
              groupByOptions={groupByOptions}
              onConfigure={onConfigure}
              applying={applying}
              applyResponse={applyResponse}
              MODEL_OPTIONS={MODEL_OPTIONS}
              ENSEMBLE_MODELS={ENSEMBLE_MODELS}
              onBackToDashboard={onBackToDashboard}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataReviewAndConfigure;